export const APP_CONFIG = {
    APP_NAME: 'Eclipse Tint Booking',
    COMPANY_NAME: 'Eclipse Tint',
    CONTACT_EMAIL: 'info@eclipsetint.com.au',
    CONTACT_PHONE: '1300864703',
    DEFAULT_BOOKING_DURATION: 15, // minutes (phone consultation default)
    BOOKING_SLOTS_PER_DAY: 16,
    MAX_BOOKING_DAYS_AHEAD: 30,
    SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds
};

export const DEFAULT_PAIN_POINTS = [
    {
        id: 'uv-privacy',
        name: 'UV / Privacy / Heat & Glare',
        description: 'Protect your space from harmful UV rays while maintaining privacy and reducing heat and glare.',
        active: true
    },
    {
        id: 'thermal',
        name: 'Winter Thermal Insulation',
        description: 'Improve energy efficiency and comfort with enhanced insulation during colder months.',
        active: true
    },
    {
        id: 'security',
        name: 'Security and Safety',
        description: 'Strengthen glass security and safety with protective film solutions.',
        active: true
    }
];

// Film type recommendations based on pain points
export const FILM_RECOMMENDATIONS = {
    'uv-privacy': {
        name: 'Premium Solar Control Film',
        description: 'High-performance film that blocks up to 99% of UV rays while providing excellent heat rejection and privacy.',
        benefits: ['99% UV protection', 'Superior heat rejection', 'Enhanced privacy', 'Glare reduction']
    },
    'thermal': {
        name: 'Low-E Thermal Insulation Film',
        description: 'Advanced low-emissivity film designed to improve winter insulation and year-round energy efficiency.',
        benefits: ['Winter heat retention', 'Energy savings', 'Improved comfort', 'Clear visibility']
    },
    'security': {
        name: 'Safety & Security Film',
        description: 'Thick, durable film that holds glass together upon impact, providing enhanced safety and security.',
        benefits: ['Shatter resistance', 'Break-in protection', 'Storm protection', 'Clear appearance']
    }
};

// Function to get current pain points from settings (localStorage) or defaults
export const getPainPoints = () => {
    try {
        const stored = localStorage.getItem('eclipse-pain-points');
        if (stored) {
            const painPoints = JSON.parse(stored);
            return painPoints.filter((p: any) => p.active);
        }
    } catch (error) {
        console.warn('Failed to load pain points from localStorage:', error);
    }
    return DEFAULT_PAIN_POINTS.filter(p => p.active);
};

// Legacy export for backward compatibility - will be replaced by settings
export const PAIN_POINTS = DEFAULT_PAIN_POINTS;

export const BOOKING_OPTIONS = [
    { id: 'estimate', label: 'Get an Estimate', description: 'Price Estimation from Measurements', duration: 15 },
    { id: 'consultation', label: 'Book Consultation', description: 'Phone / Onsite Booking', duration: 15 }
];

export const TIME_SLOTS = {
    MORNING: { start: '09:00', end: '12:00', label: 'Morning' },
    AFTERNOON: { start: '13:00', end: '17:00', label: 'Afternoon' }
};

export const BOOKING_STATUSES = {
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
} as const;

export const LEAD_STAGES = {
    CONTACT: 'contact',
    MEASUREMENT: 'measurement',
    BOOKING: 'booking',
    COMPLETED: 'completed',
    DROPPED: 'dropped'
} as const;

export const VALIDATION_RULES = {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE_REGEX: /^(\+61|0)[2-9]\d{8}$/,
    MIN_NAME_LENGTH: 2,
    MAX_NAME_LENGTH: 50,
    MIN_ADDRESS_LENGTH: 10,
    MAX_ADDRESS_LENGTH: 200
};

export const COLORS = {
    PRIMARY: '#F59E0B', // Amber-500
    PRIMARY_DARK: '#D97706', // Amber-600
    SECONDARY: '#1F2937', // Gray-800
    SUCCESS: '#10B981', // Emerald-500
    ERROR: '#EF4444', // Red-500
    WARNING: '#F59E0B', // Amber-500
    INFO: '#3B82F6', // Blue-500
};
